<div id="accueil"
  *ngIf="!estAuthentifie"
  class="container">
  <div class="row">
    <h1>{{'accueil.titre' | translate}}</h1>
    <p #descPublic class="paragraphe"
      [innerHTML]="'accueil.description' | translate"></p>
  </div>

  <div *ngIf="!estAuthentifie"
    class="row">
    <div class="col-12 mt-5 mb-5">
      <img src="./assets/images/accueil/2-acoa.jpg"
        style="width: 100%; height: 628px" />



      <!-- <ngb-carousel *ngIf="images" id="carousel">
        <ng-template ngbSlide *ngFor="let image of images">
          <div class="picsum-img-wrapper">
            <img [src]="image.url" [alt]="image.alt" />
          </div>
        </ng-template>
      </ngb-carousel> -->
    </div>
  </div>
</div>

<app-accueil-avec-acces *ngIf="estAuthentifie"></app-accueil-avec-acces>